import React, { useState } from 'react';
import {Button, notification, Popconfirm, Row, } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { UserSwitchOutlined } from '@ant-design/icons';
import { AssignProcTask } from '../services/workflow';
import AuthorizedUsersInput from './AuthorizedUsersInput';
import FormInput from './FormInput';

export type TaskAssignToUserButtonProps = ButtonProps & {
  proctaskid: number;
  label: string;
  refetch: () => void;
};

const TaskAssignToUserButton: React.FC<TaskAssignToUserButtonProps> = ({
  size = 'small',
  refetch,
  proctaskid,
  label,
  ...props
}) => {
  const [userid, setUserid] = useState<any>();

  return (
    <div style={{margin:"auto"}}>
    
      <Row>
        <FormInput name="selectUser" style={{ width: '200px' }} noStyle>
          <AuthorizedUsersInput onChange={setUserid} />
        </FormInput>
        </Row>
        <Row style={{ marginTop:"10px"}}>
        <Popconfirm
          title="Are you sure?"
          onConfirm={() => {
            if (userid !== null) {
              AssignProcTask({
                proctaskidList: [{ proctaskid: proctaskid }],
                userid,
              }).then((resp) => {
                if (resp.code === '200') {
                  notification.success({ message: resp.message });
                  refetch();
                } else {
                  notification.error({ message: resp.message });
                }
              });
            }
          }}
          okText="Yes"
          cancelText="No"
        >
          <Button icon={<UserSwitchOutlined />} {...props} style={{width:"200px"}}>
            {label}
          </Button>
        </Popconfirm>
        </Row>
      </div>
  );
};

export default TaskAssignToUserButton;
